import DiscoveryLayer from "./DiscoveryLayer";

export default DiscoveryLayer;
